"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomImager = void 0;
const pixi_js_1 = require("pixi.js");
const Cube_1 = require("../../engine/geometry/Cube");
const isometric_1 = require("../../engine/isometric");
const IsoPoint_1 = require("../../engine/lib/IsoPoint");
const injets_1 = require("injets");
const application_provider_1 = require("../pixi/application.provider");
const DEFAULT_THICKNESS = 8;
const TEXTURE_RESOLUTION = window.devicePixelRatio * 3;
function createStairSteps(cb, thickness = DEFAULT_THICKNESS) {
    return new Array(4).fill(null).map((_, index) => {
        const { height = thickness, depth = thickness, width = thickness, position = new isometric_1.Vector3() } = cb(index);
        return new Cube_1.Cube({ depth, height, width, position });
    });
}
let RoomImager = class RoomImager {
    constructor(appProvider) {
        this.appProvider = appProvider;
        this.tileCache = {};
        this.wallsCache = {};
    }
    generateFloorTileTexture(thickness = DEFAULT_THICKNESS) {
        const cacheName = `floor_${thickness}`;
        if (cacheName in this.tileCache)
            return this.tileCache[cacheName];
        const floor = new Cube_1.Cube({
            depth: 32,
            height: thickness,
            width: 32,
        });
        const borderStroke = new pixi_js_1.Polygon([
            new isometric_1.Vector3(1, 31, 0).toVector2(),
            new isometric_1.Vector3(1, 1, 0).toVector2(),
            new isometric_1.Vector3(31, 1, 0).toVector2(),
        ]);
        borderStroke.closeStroke = false;
        floor.lineStyle(2, 0x000000, 0.05);
        floor.drawShape(borderStroke);
        return (this.tileCache[cacheName] = this.appProvider.app.renderer.generateTexture(floor, pixi_js_1.SCALE_MODES.NEAREST, TEXTURE_RESOLUTION));
    }
    generateStairTexture(direction, thickness = DEFAULT_THICKNESS) {
        const g = new pixi_js_1.Graphics();
        const border = new pixi_js_1.Graphics();
        const borderPolygon = new pixi_js_1.Polygon();
        let hitArea = new pixi_js_1.Polygon([
            new isometric_1.Vector3(32, 0).toVector2(),
            new isometric_1.Vector3(64, 0).toVector2(),
            new isometric_1.Vector3(64, 32).toVector2(),
            new isometric_1.Vector3(31, 32).toVector2(),
        ]);
        if (direction === 0) {
            g.addChild(...createStairSteps((i) => ({
                width: 32,
                position: new isometric_1.Vector3(0, (i / 4) * 32, 8 * i - 32),
            })));
            hitArea = new pixi_js_1.Polygon([
                new isometric_1.Vector3(32, 16).toVector2(),
                new isometric_1.Vector3(78, 16).toVector2(),
                new isometric_1.Vector3(78, 32).toVector2(),
                new isometric_1.Vector3(31, 32).toVector2(),
            ]);
        }
        else if (direction === 1) {
            g.addChild(...createStairSteps((i) => {
                const size = 32 - (i / 4) * 32;
                return {
                    width: size,
                    depth: size,
                    position: new isometric_1.Vector3(0, 32 - size, 8 * i - 24),
                };
            }));
            hitArea = new pixi_js_1.Polygon([
                new isometric_1.Vector3(16, 8, 0).toVector2(),
                new isometric_1.Vector3(64, 0, -16).toVector2(),
                new isometric_1.Vector3(64, 32, -16).toVector2(),
                new isometric_1.Vector3(31, 32, 16).toVector2(),
            ]);
        }
        else if (direction === 2) {
            g.addChild(...createStairSteps((i) => ({
                depth: 32,
                position: new isometric_1.Vector3((i / -4) * 32, 0, 8 * i),
            })));
            hitArea = new pixi_js_1.Polygon([
                new isometric_1.Vector3(32, 0, 16).toVector2(),
                new isometric_1.Vector3(64, 0, -16).toVector2(),
                new isometric_1.Vector3(64, 32, -16).toVector2(),
                new isometric_1.Vector3(31, 32, 16).toVector2(),
            ]);
        }
        else if (direction === 3) {
            g.addChild(...createStairSteps((i) => {
                const size = 32 - (i / 4) * 32;
                return {
                    width: size,
                    depth: size,
                    position: new isometric_1.Vector3(0, 0, 8 * i),
                };
            }));
            hitArea = new pixi_js_1.Polygon([
                new isometric_1.Vector3(32, 0, 16).toVector2(),
                new isometric_1.Vector3(64, 0, -16).toVector2(),
                new isometric_1.Vector3(64, 32, -16).toVector2(),
                new isometric_1.Vector3(31, 32, -16).toVector2(),
            ]);
        }
        else if (direction === 4) {
            g.addChild(...createStairSteps((i) => ({
                width: 32,
                position: new isometric_1.Vector3(0, (i / -4) * 32, 8 * i),
            })));
            hitArea = new pixi_js_1.Polygon([
                new isometric_1.Vector3(32, 0, 16).toVector2(),
                new isometric_1.Vector3(64, 0, 16).toVector2(),
                new isometric_1.Vector3(64, 32, -16).toVector2(),
                new isometric_1.Vector3(32, 32, -16).toVector2(),
            ]);
        }
        else if (direction === 5) {
            g.addChild(...createStairSteps((i) => {
                const size = 32 - (i / 4) * 32;
                return {
                    width: size,
                    depth: size,
                    position: new isometric_1.Vector3(32 - size, 0, 8 * i - 24),
                };
            }));
            hitArea = new pixi_js_1.Polygon([
                new isometric_1.Vector3(54, 0, 16).toVector2(),
                new isometric_1.Vector3(64, 0, 16).toVector2(),
                new isometric_1.Vector3(64, 32, -16).toVector2(),
                new isometric_1.Vector3(32, 32, -16).toVector2(),
            ]);
        }
        else if (direction === 6) {
            g.addChild(...createStairSteps((i) => ({
                depth: 32,
                position: new isometric_1.Vector3((i / 4) * 32, 16, 8 * i - 16),
            })));
            hitArea = new pixi_js_1.Polygon([
                new isometric_1.Vector3(40, -16).toVector2(),
                new isometric_1.Vector3(56, -16).toVector2(),
                new isometric_1.Vector3(56, 48).toVector2(),
                new isometric_1.Vector3(40, 48).toVector2(),
            ]);
        }
        else if (direction === 7) {
            g.addChild(...createStairSteps((i) => {
                const size = 32 - (i / 4) * 32;
                return {
                    width: size,
                    depth: size,
                    position: new isometric_1.Vector3(64 - size, 64 - size, 8 * i),
                };
            }));
            hitArea = new pixi_js_1.Polygon([]);
        }
        borderPolygon.closeStroke = false;
        border.lineStyle(2, 0x000000, 0.05);
        // border.lineStyle(2, 0xFF0000, 1, 0)
        border.drawPolygon(borderPolygon);
        g.addChild(border);
        return this.appProvider.app.renderer.generateTexture(g, pixi_js_1.SCALE_MODES.NEAREST, TEXTURE_RESOLUTION);
    }
    generateWallTexture(direction, width = 32, height = 100, door = false, thickness = 8, conner = false, elevation = 0) {
        const walls = new pixi_js_1.Graphics();
        const cacheName = [direction, width, height, door, thickness, conner].join('_');
        if (cacheName in this.wallsCache)
            return this.wallsCache[cacheName];
        if (door) {
            height -= elevation + 80;
        }
        const cubeOptions = {
            height: height,
            position: new isometric_1.Vector3(0, 0, 0),
            colors: {
                top: 0x6f717a,
                front: 0x9597a3,
                left: 0xb6b8c7,
            },
        };
        if (conner) {
            walls.addChild(new Cube_1.Cube(Object.assign(Object.assign({}, cubeOptions), { position: new isometric_1.Vector3(0, -thickness, 0), width: thickness, depth: thickness })));
        }
        // Vertical
        if (direction === 0) {
            walls.addChild(new Cube_1.Cube(Object.assign(Object.assign({}, cubeOptions), { width: thickness, depth: width })));
        }
        // Horizontal
        if (direction === 1) {
            walls.addChild(new Cube_1.Cube(Object.assign(Object.assign({}, cubeOptions), { width: width, depth: thickness })));
        }
        if (door && elevation > 0) {
            cubeOptions.position.z -= height + 80;
            // Vertical
            if (direction === 0) {
                walls.addChild(new Cube_1.Cube(Object.assign(Object.assign({}, cubeOptions), { height: elevation, width: thickness, depth: width })));
            }
            // Horizontal
            if (direction === 1) {
                walls.addChild(new Cube_1.Cube(Object.assign(Object.assign({}, cubeOptions), { height: elevation, width: width, depth: thickness })));
            }
        }
        return (this.wallsCache[cacheName] = this.appProvider.app.renderer.generateTexture(walls, pixi_js_1.SCALE_MODES.NEAREST, TEXTURE_RESOLUTION));
    }
    generateFloorSelectionTexture() {
        const g = new pixi_js_1.Graphics();
        const polygon = new pixi_js_1.Polygon([
            new IsoPoint_1.IsoPoint(0, 0).toPoint(),
            new IsoPoint_1.IsoPoint(32, 0).toPoint(),
            new IsoPoint_1.IsoPoint(32, 32).toPoint(),
            new IsoPoint_1.IsoPoint(0, 32).toPoint(),
        ]);
        g.lineStyle(2, 0xff73ba, 1, 0);
        g.drawPolygon(polygon);
        return this.appProvider.app.renderer.generateTexture(g, pixi_js_1.SCALE_MODES.NEAREST, TEXTURE_RESOLUTION);
    }
};
RoomImager = __decorate([
    injets_1.Provider(),
    __metadata("design:paramtypes", [application_provider_1.ApplicationProvider])
], RoomImager);
exports.RoomImager = RoomImager;
